module.exports = __webpack_public_path__ + "static/media/gada 1.4106d288.png";